export const getColumnWidth = (windowWidth: number) => {
  if (windowWidth < 768) return 100;
  if (windowWidth < 1024) return 200;
  return 300;
};
